import React from 'react'
import { Link } from "react-router-dom";


const IntroSections = (props) => {
  return (
    <section className='intro_section'>
          <div className='intro'>
               <h1>{ props.sectionName }</h1>

          <ul>
              <li > <Link to="/"> Home </Link> </li>
              <li>/</li>
              <li > {props.sectionLink} </li>

          </ul>
         </div>
    </section>
  )
}

export default IntroSections